import { formatDateInput } from './helpers';

// ATLAS API
export const ATLAS_API = {
  url: window.ENV.ATLAS_URL,
  subscriptionKey: window.ENV.ATLAS_SUBSCRIPTION_KEY,
  apiVersion: window.ENV.ATLAS_API_VERSION,
  countrySet: window.ENV.ATLAS_COUNTRY_SET,
};

export const ACCOUNT_TYPES = [
  {
    value: 'checking',
    text: 'Checking',
  },
  {
    value: 'savings',
    text: 'Savings',
  },
];

export const api = {
  url: window.ENV.COSMOS_API_URL,
  methods: {
    trips: '/trips',
    tripsMultiple: '/trips/multiple',
    passengers: '/passengers',
    providers: '/providers',
    providersEtas: '/providers/etas',
    prices: '/prices',
    locations: '/locations',
    etas: '/providers/etas',
    users: '/users',
    clients: '/clients',
    clientsPrograms: '/clients/programs',
    servicePlans: '/serviceplans',
    capitation: '/capitation',
    exceptions: '/trips/exceptions',
    exceptionsByTrip: '/trips/exceptions/exceptions-by-trip',
    tripsExceptions: '/trips/trips-with-exceptions',
    events: '/trips/events',
    driverCallMessage: '/drivercallmessage',
    drivers: '/providers/drivers',
  },
  ocpApimSubscriptionKey: window.ENV.COSMOS_API_SUSCRIPTION_KEY,
};

export const googleApi = {
  methods: {
    distancematrix: '/googlewrapper/distancematrix'
  },
  subscriptionKey: window.ENV.GOOGLE_API_KEY,
}

export const STATES = [
  // { name: "isAllStates", isChecked: true, label: "All", value: "allStates" },
  { name: "isArizona", isChecked: true, label: "Arizona", value: "AZ" },
  { name: "isCalifornia", isChecked: true, label: "California", value: "CA" },
  { name: "isColorado", isChecked: true, label: "Colorado", value: "CO" },
  { name: "isNevada", isChecked: true, label: "Nevada", value: "NV" },
  { name: "isNewMexico", isChecked: true, label: "New Mexico", value: "NM" },
  { name: "isTexas", isChecked: true, label: "Texas", value: "TX" },
  { name: "isWashington", isChecked: true, label: "Washington", value: "WA" },
]

export const USER_ROLES = 'HoustonUser';

export const DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_FORMAT_EVENTS = "YYYY-MM-DD";
export const TIME_FORMAT_24_EVENTS = "HH:mm";
export const TIME_FORMAT_24_SECONDS = "HH:mm:ss";
export const TIME_FORMAT_12 = 'hh:mm:ss a';
export const TIME_FORMAT_24 = 'HH:mm:ss';
export const SHORT_DATE_FORMAT = 'MM/DD';
export const SHORT_TIME_FORMAT_24 = 'HH:mm';
export const SHORT_TIME_FORMAT_12 = 'hh:mm a';
export const SHORT_TIME_FORMAT_12A = 'hh:mm A';
export const DATE_TIME_FORMAT_12 = `${DATE_FORMAT} ${TIME_FORMAT_12}`;
export const DATE_TIME_FORMAT_24 = `${DATE_FORMAT} ${TIME_FORMAT_24}`;
export const DATE_TIME_FORMAT_EVENTS = `${DATE_FORMAT_EVENTS} ${TIME_FORMAT_24_EVENTS}`;
export const SHORT_DATE_TIME_FORMAT_12 = `${SHORT_DATE_FORMAT} ${SHORT_TIME_FORMAT_12}`
export const SHORT_DATE_TIME_FORMAT_24 = `${SHORT_DATE_FORMAT} ${SHORT_TIME_FORMAT_24}`;
export const LONG_DATE_TIME_FORMAT_24 =`${DATE_FORMAT_EVENTS} ${SHORT_TIME_FORMAT_12A}`;
export const DEFAULT_TIME_ZONE = 'America/Phoenix';
export const NOTE_DATE_TIME_FORMAT= `${DATE_FORMAT}, ${TIME_FORMAT_24_SECONDS}`;

export const SPECIALITIES = [
  { name: "isVip", isChecked: false, label: "VIP", value: "true" },
  { name: "isOversizeWC", isChecked: false, label: "Oversize WC", value: '3'},
  { name: "isDialysis", isChecked: false, label: "Dialysis", value: "true"}
]

export const CLIENTS = [
  // { name: "isAllClients", isChecked: true, label: "All", value: "allClients" },
  { name: "isCareMore", isChecked: true, label: "CareMore", value: "9" },
  { name: "isAnthem", isChecked: true, label: "Anthem", value: "35" },
  { name: "isIEHP ", isChecked: true, label: "IEHP ", value: "13" },
]

export const LEVELS = [
  // { name: "isAllServices", isChecked: true, label: "All", value: "allServices" },
  { name: "isambc2c", isChecked: true, label: "AMBC2C", value: "AMBC2C" },
  { name: "isambd2d", isChecked: true, label: "AMBD2D", value: "AMBD2D", },
  { name: "isambh2h", isChecked: true, label: "AMBH2H", value: "AMBH2H" },
  { name: "isals", isChecked: true, label: "ALS", value: "ALS" },
  { name: "isbargur", isChecked: true, label: "BARGUR", value: "BARGUR" },
  { name: "isbls", isChecked: true, label: "BLS", value: "BLS" },
  { name: "isgurney", isChecked: true, label: "GUR", value: "GUR" },
  { name: "iswcc2c", isChecked: true, label: "WCC2C", value: "WCC2C" },
  { name: "iswcd2d", isChecked: true, label: "WCD2D", value: "WCD2D" },
  { name: "iswch2h", isChecked: true, label: "WCH2H", value: "WCH2H" },
]

export const FROM_TO_DATE_TIME = [
  { name: "fromDateTime", label: "From Date/Time", date: formatDateInput(new Date()), time: "00:00" },
  { name: "toDateTime", label: "To Date/Time", date: formatDateInput(new Date()), time: "23:59" }
]

export const TRIP_STATUS = [
  { name: "isconfirmed", isChecked: true, label: "Confirmed", value: "Confirmed" },
  { name: "isoffered", isChecked: true, label: "Offered", value: "Offered", },
  { name: "isaccepted", isChecked: true, label: "Accepted", value: "Accepted" },
  { name: "isonsite", isChecked: true, label: "Onsite", value: "Onsite" },
  { name: "isonboard", isChecked: true, label: "Onboard", value: "Onboard" },
  { name: "isnoload", isChecked: true, label: "Noload", value: "Noload" },
  { name: "iscomplete", isChecked: true, label: "Complete", value: "Complete" },
  { name: "iscanceled", isChecked: true, label: "Canceled", value: "Canceled" },
  { name: "isvoid", isChecked: true, label: "Void", value: "Void" },
]


export const CSV_CONFIG = {
  headers: [
    { label: 'Due', key: 'dueDateTime' },
    { label: 'Service Level', key: 'serviceLevel' },
    { label: 'First Name', key: 'passengerFirstName' },
    { label: 'Last Name', key: 'passengerLastName' },
    { label: 'PU Phone #', key: 'pickupPhone' },
    { label: 'PU Address', key: 'pickupAddressLine1' },
    { label: 'PU Address Line 2', key: 'pickupAddressLine2' },
    { label: 'PU City', key: 'pickupCity' },
    { label: 'PU State', key: 'pickupState' },
    { label: 'DO Address', key: 'dropoffAddressLine1' },
    { label: 'DO Address Line 2', key: 'dropoffAddressLine2' },
    { label: 'DO City', key: 'dropoffCity' },
    { label: 'Miles', key: 'tripMiles' },
    { label: 'Transportation Provider', key: 'serviceProviderName' },
    { label: 'Driver', key: 'driverName' },
    { label: 'Bolt Trip ID', key: 'boltTripId' },
  ],
  separator: ',',
  enclosingCharacter: `'`
}

export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})


export const shownByRadioComplete = ['pickupEventTime', 'onsiteEventTime', 'dropoffEventTime'];
export const shownByRadioNoload = ['onsiteEventTime', 'noShowEventTime'];

const AMERICAN_EXPRESS = 'American Express';
const DISCOVER = 'Discover';
const JCB = 'JCB';
const DINNERS = 'Diners Club/ Carte Blanche';
const VISA = 'Visa';
const MASTERCARD = 'Mastercard';

export const CARD_COMPANIES = [
  {
    value: AMERICAN_EXPRESS,
    text: AMERICAN_EXPRESS,
  },
  {
    value: DISCOVER,
    text: DISCOVER,
  },
  {
    value: JCB,
    text: JCB,
  },
  {
    value: DINNERS,
    text: DINNERS,
  },
  {
    value: VISA,
    text: VISA,
  },
  {
    value: MASTERCARD,
    text: MASTERCARD,
  },
];

export const ExceptionType = {
  smsFailed: 1,
  reject: 2,
  modified: 3
}

export const ExceptionSource = {
  boltDriverApp: 1,
  boltDriverWeb: 2,
  relayWebApp: 3,
  lauchpadWebApp: 4,
  passengerMobileApp: 5,
  twilio: 6,
  bolrProviderWeb: 7
}

export const CapitationMeasure = {
  trips: "trips",
  miles: "miles"
};

export const tripResponseError =
  [
    {
      error: 'Current Eligibility information not found in XDispPassEligibility.',
      message: "Current Elegibility information not found. Please call us at 866-999-3371 x300"
    }
  ];

export const globalKeyMap = {
  OPEN_MENU: '/'
}

export const keyMap = {
  GOTO_EXCEPTIONS: 'e',
  GOTO_OPEN_TRIPS: 'o',
  GOTO_LATE_TRIPS: 'l',
  GOTO_PROVIDER_TRIPS: 'p',
  GOTO_OUT_OF_NETWORK: 'n',
  GOTO_TRIP_SEARCH: 't',
  GOTO_RIDESHARE_TRIPS: 'r',
  GOTO_CLIENTES_PROGRAMS: 'c',
  GOTO_RELAY_USERS: 'u',
  GOTO_MARKETPLACE_USERS: 'm'
}

export const CANCEL_TRIP_REASONS = [
  { name: 'isTripDeclined', label: 'Trip Declined', value: 1 },
  { name: 'isPassengerCanceled', label: 'Passenger Canceled', value: 2 },
  { name: 'isClientCanceled', label: "Client Canceled", value: 3 },
  { name: 'isDuplicateTrip', label: 'Duplicate Trip', value: 4 },
  { name: 'isTripNotConfirmedByAnyProvider', label: 'Trip Not Confirmed By Any Provider', value: 5 },
  { name: 'isProviderArrivedOutsideWindow', label: 'Provider Arrived Outside Window', value: 6 },
  { name: 'isUnusedWillCall', label: 'Unused WillCall', value: 7 },
]

export const ERROR_TOAST_ICON = 'warning-sign';
